<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>清除帐号设备绑定</div>
        </div>
        <el-collapse-transition>
          <div>
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="form.app"
                    placeholder="app版本"
                    style="width: 150px"
                  >
                    <el-option label="代采版" value="buyer"></el-option>
                    <el-option label="仓储版" value="storage"></el-option>
                    <el-option label="朱雀pda" value="suzaku"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.name"
                    placeholder="帐号名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-button type="primary" @click="comfresh">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resData: null,
      form: {
        name: "",
        app: "",
      },
    };
  },

  methods: {
    comfresh() {
      const url = "/erp/CacheHandle/freshCacheDevice";
      const data = {
        admin_name: this.form.name || "",
        app: this.form.app || "",
      };
      this.$http.post(url, data).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/CacheDevice.vue